'use strict';

angular.module('atex.dam').controller('DamListController', ['$rootScope', '$scope', 'DamPreviewModalController', '$translate', '$modal','$q', '$state',
'DamService','$timeout','$interval', '$sce', '$filter', 'ContentService', 'DamListService', 'DamConfigurationService','$window', 'DamSearchService', 'DamQueryService', 'DamNotificationService', 'DamActivityService', 'DamFoldersService', 'DamQueuesService', 'DamSocialNotificationService' ,'DamStatusService','configuration', 'UserProfileService',
function($rootScope, $scope, DamPreviewModalController, $translate, $modal, $q, $state, DamService, $timeout, $interval, $sce, $filter,
    ContentService, DamListService, DamConfigurationService, $window, DamSearchService, DamQueryService, DamNotificationService, DamActivityService, DamFoldersService, DamQueuesService, DamSocialNotificationService, DamStatusService, configuration, UserProfileService) {

  // CFG values
  $scope.currentLineHeight = 150;
  $scope.entries = DamListService.getEntries();
  $scope.selected = DamListService.getSelected();
  $scope.thumb_list = !$rootScope.listBudget;
  $scope.listBudget = $rootScope.listBudget;
  $scope.list = false;
  $scope.thumb = false;
  $scope.grid = false;
  $scope.jobs = false;
  $scope.physPage = false;
  $scope.fullscreen = false;

  $scope.querying = false;
  $scope.numFound = 0;
  $scope.physPageSize = 0;
  $scope.initialPhysPageSize = 0;
  $scope.nextStart = 0;
  $scope.showloadmore = false;
  $scope.toggle = "col-lg-7";
  $scope.hideIcon = "col-lg-2";
  var maxResultDynQry = configuration.getMaxResultForDynamicSearch();

  $scope.newDynEntries = [];

  $scope.autoShowNewItem = false;

  var defaultDocTitle = document.title;
  var currDocTitle = defaultDocTitle;

  var newDynContentAlert = false;

  function setDocTitle(title) {
    $timeout(function() {
      var _title = (title === defaultDocTitle) ? defaultDocTitle : title + " " + defaultDocTitle;
      document.title = _title;
    });
  }

  $scope.attributes = [];
  DamStatusService.getAttributesList().then(function(attrs) {
    attrs.forEach(function (attribute) {
      if (attribute.views.includes("list")) {
        var attr = {
          id: attribute.attributeID,
          name: attribute.name,
          shortName: attribute.shortName,
          icon: attribute.icon
        };
        $scope.attributes.push(attr);
      }
    });
  }).then(null, function (error) {
    var message = 'Error: ' + error.cause;
    if ($translate.getTranslationTable() !== null) {
      message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
    }
    DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
  });

  $scope.getAttributesList = function (attrs) {
    var rows = [];
    $scope.attributes.forEach(function (attribute) {
      var content;
      if (attrs && attrs.includes(attribute.id)) {
        content = attribute;
      }
      rows.push(content);
    });

    return rows;
  };


    $scope.showBudgetView = function() {
      return configuration.getShowBudgetView();
    };

  $scope.toggleAutoShowNewItem = function() {
    $scope.autoShowNewItem = !$scope.autoShowNewItem;
    if ($scope.autoShowNewItem === true) {
      // Flush already collected docs
      $scope.showNewItems();
    }
  };

  $scope.chooseRowSize = function(param,digest) {
	  $scope.hideIcon = "col-lg-2";
	  $scope.thumbSliderStart=2;

	  if(param < 1360) {
		  $scope.hideIcon = "col-lg-4";
		  $scope.thumbSliderStart=4;
	  } else if (param < 2015) {
		  $scope.hideIcon = "col-lg-3";
		  $scope.thumbSliderStart=3;
	  } else {
		  $scope.hideIcon = "col-lg-2";
		  $scope.thumbSliderStart=2;
	  }

	  if(digest) {
		  $scope.$apply();
	  }
  };

  var w = angular.element($window);

  w.bind("resize",function() {
	  $scope.chooseRowSize(w.width(),true);
  });

  $scope.suggestion = '';
  $scope.suggestedSearchResponseData = undefined;
  $scope.simpleSearch = false;

  $scope.relatedsearches = [];

  $scope.limitDesc = 250;

  $scope.firstTickSpan = 10;
  $scope.firstTickSpanList = 25;
  $scope.tickSpan = 10;
  $scope.tick = $scope.tickSpan;

  $scope.showList = true;

  $scope.isDynamicQuery = false;

  $scope.clearSelection = function() {
    DamListService.clearSelection();
  };

  var updatingSearch = false;
  var loadingMore = false;
  var lastAdvContainer;
  var lastAdvdamid;
  var dynamicLoadMoreFilterQuery;

  $scope.resetlist = function(emptyList) {
    $scope.newDynEntries.length = 0;
    $scope.tick = $scope.firstTickSpan;
    if (emptyList === true) {
      DamListService.clearEntries();
    }
    $scope.numFound = 0;
    $scope.nextStart = 0;
    $scope.showloadmore = false;
    $scope.clearSelection();
    $scope.suggestion = "";
    $scope.relatedsearches.length = 0;
    updatingSearch = false;
    loadingMore = false;
    lastAdvContainer = undefined;
    lastAdvdamid = undefined;
    dynamicLoadMoreFilterQuery = undefined;
    maxResultDynQry = configuration.getMaxResultForDynamicSearch();
  };

  // Handle login / logout
  $scope.$on("dam:logout", function() {
    $scope.resetlist(true);
  });

  $scope.$on("dam:count-items", function(event, size) {
    $scope.initialPhysPageSize = angular.copy(size);
    $scope.physPageSize = angular.copy(size);
  });

  $scope.$on("dam:add-count-items", function(event, size) {
    $scope.physPageSize = Number($scope.initialPhysPageSize) + Number(size);
  });

  var resetExtraInfo = function() {
    $scope.stopPoll();
    delete $scope.containerName;
    delete $scope.queryName;
    delete $scope.folderId;
    delete $scope.isSmartFolder;
    delete $scope.extraInfo;
  };

  var getCurrentViewMode = function() {
    if ($scope.thumb_list) {
      return 'thumb_list';
    } else if ($scope.list) {
      return 'list';
    } else if ($scope.thumb) {
      return 'thumb';
    } else if ($scope.grid) {
      return 'grid';
    } else if ($scope.jobs) {
      return 'jobs';
    } else if ($scope.physPage) {
      return 'physical-page';
    } else if ($scope.listBudget) {
        return 'budget-list';
      } else {
      console.log("WARNING: Check why a current view type is not set here! Returning 'thumb_list' as default...");
      return 'thumb_list';
    }
  };

  // Handle querying
  $scope.$on("dam:initSearch", function(event, extraInfo) {
    resetExtraInfo();
    $scope.querying = true;
    $scope.showList = false;
    $scope.newDynEntries.length = 0;
    // Check the extraInfo
    $scope.extraInfo = extraInfo;
    if ($scope.extraInfo === undefined) {
      if (getCurrentViewMode() === 'physical-page') {
        $scope.show('thumb-list', true);
      }
    }
    if ($scope.extraInfo) {
      // We are listing a stored query or a physic/smart folder
      var type = atex.onecms.ObjectUtils.accessor($scope.extraInfo, 'type').value;
      if (type === 'atex.dam.standard.Folder') {
        $scope.containerName = atex.onecms.ObjectUtils.accessor($scope.extraInfo, 'data/aspects/contentData/data/name').value;
        $scope.folderId = atex.onecms.ObjectUtils.accessor($scope.extraInfo, 'id').value;
        $scope.isSmartFolder = atex.onecms.ObjectUtils.accessor($scope.extraInfo, 'data/aspects/contentData/data/smartFolder').value;
        var dbViewMode = atex.onecms.ObjectUtils.accessor($scope.extraInfo, 'data/aspects/contentData/data/viewMode').value;
        if (dbViewMode!==getCurrentViewMode()) {
          $scope.show(dbViewMode, true);
        }
      } else if (type === 'webSection') {
        $scope.containerName = atex.onecms.ObjectUtils.accessor($scope.extraInfo, 'name').value;
        $scope.folderId = atex.onecms.ObjectUtils.accessor($scope.extraInfo, 'id').value;
        var sectionViewMode = atex.onecms.ObjectUtils.accessor($scope.extraInfo, 'viewMode').value;
        if (sectionViewMode !== getCurrentViewMode()) {
          $scope.show(sectionViewMode, true);
        }
      } else {
        var viewMode = $scope.extraInfo.viewMode;
        if (!viewMode) {
          // Here only for advanced (Physical Page search always pass 'physical-page' as viewMode), so we only need to
          // check if we are in 'physical-page' and, in that case, switch to the default 'thumb-list' view [max]
          if (getCurrentViewMode() === 'physical-page') {
            viewMode = 'thumb-list';
          } else {
            viewMode = getCurrentViewMode();
          }
        }
        if (viewMode !== undefined) {
          $scope.show(viewMode, true);
        }

        DamFoldersService.resetSelection(true);
        DamQueuesService.resetSelection(true);
      }
    }
  });

  $scope.$on("dam:resetViewMode", function() {
    if (getCurrentViewMode() === "physical-page") {
      $scope.show("thumb-list", true);
    }
  });

  $scope.$on("dam:setViewMode", function(event, view) {
    if (view !== getCurrentViewMode()) {
      $scope.show(view,true);
    }
  });

  $scope.$on("dam:startNewQuery", function(event, resetList) {
    $scope.querying = true;
    $scope.relatedsearches = [];
    $scope.showList = false;
    $scope.resetlist(resetList);
  });

  $scope.$on("dam:beforeExecuteQuery", function() {
    $scope.querying = true;
    $scope.stopPoll();
  });

  $scope.$on("dam:afterExecuteQuery", function(event, isDynamic) {
    $scope.showList = true;
    $scope.querying = false;
    $scope.nextStart += DamService.getRows();
    if (isDynamic === true) {
      $scope.poll();
    } else {
      $scope.stopPoll();
    }
  });

  $scope.$on('dam:toggle', function(event) {
    $scope.toggle = ($scope.toggle === "col-lg-7") ? "list" : "col-lg-7";
  });

  $scope.$on('dam:reset-toggle', function(event) {
    $scope.toggle = "col-lg-7";
    $scope.$apply();
  });

//  $scope.swipeme = function() {
//    if (DamService.isMobileDevice()) {
//      $rootScope.$broadcast("dam:toggle");
//    }
//  };

  $scope.suggest = function() {
    if (DamFoldersService.listingFolder) {
      DamFoldersService.executeQuery(DamFoldersService.listingFolder, $scope.suggestion);
    } else if (DamQueuesService.listingFolder) {
      DamQueuesService.executeQuery(DamQueuesService.listingFolder, $scope.suggestion);
    }else if ($scope.simpleSearch) {
      DamSearchService.simpleSearch($scope.suggestion);
    } else {
      DamSearchService.setAdvSearchData($scope.suggestedSearchResponseData);
      DamSearchService.refresh();
    }
  };

  function asyncShowList(appendTick, fromShift) {
    if (!appendTick) {
      if ($scope.list) {
        $scope.tick = $scope.firstTickSpanList;
      } else {
        $scope.tick = $scope.firstTickSpan;
      }
    }
    var repeatAsyncHack = function () {
      if ($scope.tick < $scope.entries.length) {
        if (!fromShift) {
          $scope.showloadmore = false;
        }
        $scope.tick += $scope.tickSpan;
        $timeout(function () {
          repeatAsyncHack();
        }, 10, false);
      } else {
        if (!fromShift) {
          $scope.showloadmore = $scope.numFound > ($scope.entries.length + $scope.newDynEntries.length);
        }
      }
      $scope.$digest();
    };
    $timeout(function () {
      repeatAsyncHack();
    }, 20, false);
  }

  function getMinSolrVersion(responseDocs, maxResultDynQry) {
    var minVers = bigInt(0);
    var counter = 0;
    (responseDocs || []).forEach(function(doc) {
      if (!maxResultDynQry || counter<maxResultDynQry) {
        var _currVers = bigInt(doc.atex_desk_version);
        if (minVers.equals(0) || _currVers.lesser(minVers)) {
          minVers = _currVers;
        }
        counter++;
      }
    });
    return minVers;
  }

  function addEntries(searchResponseData) {
    if (atex.onecms.ObjectUtils.getByPath(searchResponseData, "container")!==undefined) {
      // Store last Container and damid to reuse after loadMore()
      lastAdvContainer = angular.copy(searchResponseData.container);
      lastAdvdamid =searchResponseData.damid;
      $scope.damid = lastAdvdamid;
    } else if (lastAdvContainer) {
      searchResponseData['container'] = angular.copy(lastAdvContainer);
      searchResponseData['damid'] = lastAdvdamid;
      $scope.damid = lastAdvdamid;
    }
    $scope.isDynamicQuery = atex.onecms.ObjectUtils.getByPath(searchResponseData, "container/aspects/contentData/data/isDynamic") === "true";

    var dynLoadMore = $scope.isDynamicQuery && dynamicLoadMoreFilterQuery;

    var documents = searchResponseData.response.docs;
    if (!dynLoadMore) {
      $scope.numFound = searchResponseData.response.numFound;
    }
    if ($scope.numFound <= 0) {
      if (searchResponseData.response && searchResponseData.response.start === 0) {
        DamListService.clearEntries();
      }
    }
    if (documents === undefined) {
      return;
    }
    var len = documents.length;
    if (len>0 && $scope.isDynamicQuery) {
      var oldestVersion = bigInt(searchResponseData.response.docs[len-1].atex_desk_version).subtract(1).toString();
      if (configuration.getOnlyNewInDynQuery()) {
        var min_atex_desk_version  = getMinSolrVersion(searchResponseData.response.docs);
        oldestVersion = min_atex_desk_version.subtract(1).toString();
      }
      dynamicLoadMoreFilterQuery = '-atex_desk_version:[ ' + oldestVersion + ' TO *]';
    }

    var contentWithPosterImages = ["video", "audio", "author"];
    var i = 0;
    var newEntries = [];
    var appendTick = false;
    var getChildImagePromises = [];
    documents.forEach(function(document) {
      var contentData = document._data.aspects.contentData.data;
      var imageId;
      if (contentData.objectType === "document") {
        if (contentData.posterImage && contentData.posterImage.length > 0 ) {
          imageId = contentData.posterImage[0];
        }
      //} else if (contentData.objectType === "video" || contentData.objectType === 'audio') {
      } else if (_.contains(contentWithPosterImages, contentData.objectType)) {
        if (contentData.images && contentData.images.length > 0) {
          imageId = contentData.images[0];
        } else if (contentData.resources && contentData.resources.length > 0) {
          imageId = contentData.resources[0];
        }
      }
      if (imageId) {
        getChildImagePromises.push(ContentService.getContent({id: imageId.replace("contentid/","")}).then(function (responseData) {
          var version = responseData.data.version;
          contentData.thumbUrl = "/image/" + version + "/" + version + ".jpg?w=240";
          contentData.lowUrl = "/image/" + version + "/" + version + ".jpg?w=400";
          contentData.url = "/image/" + version + "/" + version + ".jpg";
        }));
      }
    });

    // PMC-1842: some promises may fail, we will wait for all of them to be full-filled and iterate over the documents
    // array to fix what we can fix.
    $q.allSettled(getChildImagePromises).then(function () {
      documents.forEach(function(document) {
        atex.dam.AngularUtils.fixUrls(document._data);
        // Check width and depth
        atex.dam.AngularUtils.fixWidthHeight(document, $scope.currentLineHeight);
        newEntries.push(document);
        if (i === len - 1) {
          if (searchResponseData.response && searchResponseData.response.start === 0 && !dynLoadMore) {
            DamListService.clearEntries();
            DamListService.addEntries(newEntries);
          } else {
            DamListService.addEntries(newEntries);
            appendTick = true;
          }
          $scope.justifyThumbs();
        }
        i++;

      });
      asyncShowList(appendTick);
    });
  }

  function limitResult() {
    if($scope.entries.length > maxResultDynQry) {
      var oldestVersion = bigInt($scope.entries[maxResultDynQry-1].atex_desk_version).subtract(1).toString();
      if (configuration.getOnlyNewInDynQuery()) {
        var min_atex_desk_version  = getMinSolrVersion($scope.entries, maxResultDynQry);
        oldestVersion = min_atex_desk_version.subtract(1).toString();
      }
      dynamicLoadMoreFilterQuery = '-atex_desk_version:[ ' + oldestVersion + ' TO * ]';

      $scope.entries.length = maxResultDynQry;
    }
  }

  $scope.showNewItems = function() {
    if ($scope.newDynEntries.length) {
      var locArray = [];
      angular.extend(locArray, $scope.newDynEntries);
      $scope.newDynEntries.length = 0;
      shiftEntries(locArray);
      $('#dam-list-list').scrollTop(0);
      limitResult();
    }
  };

  var shiftEntries = function(documents) {
    if (!documents || documents.length<=0) {
      return;
    }
    var len = documents.length;
    var i = 0;
    documents.forEach(function(document) {
      atex.dam.AngularUtils.fixUrls(document._data);
      // Check width and depth
      atex.dam.AngularUtils.fixWidthHeight(document, $scope.currentLineHeight);
      document.isNew = true;
      /*
       * in case of updates of existing documents in the list we need to
       * remove existing entries first and notify modal dialogs that the
       * current record is out of date
       */
      $scope.entries.forEach(function(entry, index) {
        if (entry.id === document.id) {
          $scope.entries.splice(index, 1);
          $scope.numFound -= 1;
        }
      });

      $scope.entries.unshift(document);
      limitResult();

      if (i === len - 1) {
        $scope.justifyThumbs(true);
      }
      i++;

    });
    setDocTitle(currDocTitle);
    newDynContentAlert = false;
    asyncShowList(true, true);
  };

  /*
   * when an update occurs for dynamic queries we shift the resultset,
   * appending incoming content on top
   */
  var handleNewDynEntries = function(searchResponseData) {
    if (searchResponseData.response.docs && searchResponseData.response.numFound>0) {
      // Keep the oldest modification time
      if (!DamSearchService.getDynQueryStartTs(searchResponseData.damid)) {
        DamSearchService.setDynQueryStartTs(searchResponseData.damid, searchResponseData.response.docs[0]);
      }
      setDocTitle("* " + currDocTitle);
      newDynContentAlert = true;
      $scope.numFound += searchResponseData.response.numFound;
      if (!$scope.autoShowNewItem) {
        $scope.newDynEntries = $scope.newDynEntries.concat(searchResponseData.response.docs);
      } else {
        shiftEntries(searchResponseData.response.docs);
      }
    }
  };

  $scope.refresh = function() {
    DamSearchService.refresh();
  };

  /*
   * Start of Poller thread for the active dynamic query
   */
  var stop;
  var delay = 10000; // in milliseconds
  $scope.poll = function() {
    // Don't start a new poll if we are already polling
    if (angular.isDefined(stop)) {
      return;
    }
    stop = $interval(function() {
      var contentIds = $scope.entries.map(function (entry) {
        return entry.id;
      });
      // Do not update the dynamic search if document is hidden AND the 'asterisk' has been already added to the title [max]
      if ((!document.hidden || !newDynContentAlert)) {
        updatingSearch = true;
        DamSearchService.updateSearch(contentIds).finally(function () {
          updatingSearch = false;
        });
      }
    }, delay);
  };

  $scope.stopPoll = function() {
    if (angular.isDefined(stop)) {
      $interval.cancel(stop);
      stop = undefined;
    }
  };
  /*
   * End of Poller thread for the active dynamic query
   */

  function getFullTextValue(searchResponseData) {
    var tmp = searchResponseData.searchvalue;
    if (tmp === undefined || tmp === '') {
      if (searchResponseData.container !== undefined) {
        tmp = searchResponseData.container.aspects.contentData.data.fullText;
      }
    }
    return tmp;
  }

  $scope.$on("dam:search", function(event, searchResponseData) {
    addEntries(searchResponseData);

    // Check suggestion
    $scope.suggestion = "";
    $scope.suggestedSearchResponseData = undefined;

    // Check if we are querying on last days or all archive
    $scope.onlyLatest = $rootScope.lastAdvQueryData && $rootScope.lastAdvQueryData.onlyLatest;

    var title = '';
    if ($scope.extraInfo) {
      var type = atex.onecms.ObjectUtils.accessor($scope.extraInfo, 'type').value;
      if (type === 'atex.dam.standard.Folder') {
        $scope.containerName = atex.onecms.ObjectUtils.accessor($scope.extraInfo, 'data/aspects/contentData/data/name').value;
      } else {
        $scope.containerName = atex.onecms.ObjectUtils.accessor($scope.extraInfo, 'name').value;
      }
      title = $scope.containerName;
    }
    if (!$scope.containerName) {
      if (searchResponseData.damid && searchResponseData.container.aspects.contentData.data.name) {
        $scope.queryName = atex.onecms.ObjectUtils.accessor(searchResponseData, 'container/aspects/contentData/data/name').value;
        title = $scope.queryName;
      }
    }

    currDocTitle = title ? title : defaultDocTitle;
    setDocTitle(currDocTitle);
    newDynContentAlert = false;

    // ADM-211: in Solr 7.5 the suggestion is an object which includes the number of results too.
    var getSuggestedWord = function(suggestion) {
      if (suggestion && typeof suggestion !== 'string' && suggestion.word) {
        return suggestion.word;
      }
      return suggestion;
    };

    var _suggestion, tmp;
    if (searchResponseData.isFullText) {
      if ((searchResponseData.spellcheck !== undefined) && searchResponseData.spellcheck.suggestions !== undefined && searchResponseData.spellcheck.suggestions instanceof Array ) {
        searchResponseData.spellcheck.suggestions.forEach(function(suggestion,i){
          if(suggestion === searchResponseData.searchvalue.trim() ) {
            _suggestion = searchResponseData.spellcheck.suggestions[i+1];
          }
        });
      }
      $scope.simpleSearch = true;
    } else {
      if (searchResponseData.container && searchResponseData.container.aspects.contentData !== undefined) {
        tmp = searchResponseData.container.aspects.contentData.data.fullText;
        if (searchResponseData.spellcheck !== undefined) {
          _suggestion = searchResponseData.spellcheck.suggestions[tmp];
          if (_suggestion !== undefined) {
            var collation = searchResponseData.spellcheck.suggestions.collation;
            searchResponseData.container.aspects.contentData.data.solrQueryString = collation;
            $scope.simpleSearch = false;
            $scope.suggestedSearchResponseData = searchResponseData;
          }
        }
      }
    }
    if (_suggestion !== undefined) {
      if (_suggestion.suggestion.length > 0) {
        $scope.suggestion = getSuggestedWord(_suggestion.suggestion[0]);
        if (!searchResponseData.isFullText) {
          $scope.suggestedSearchResponseData.container.aspects.contentData.data.fullText = $scope.suggestion;
        }
      }
    }

    // Check related search
    $scope.relatedsearches = [];
    tmp = getFullTextValue(searchResponseData);
    if (tmp !== undefined && tmp !== '') {
      DamService.getRelatedSearch(tmp).then(function(response) {
        if ($scope.listBudget === false && response !== undefined && response.data !== undefined && response.data.interestingTerms !== undefined &&
            response.data.interestingTerms.length > 0) {
          response.data.interestingTerms.forEach(function(entry, index) {
            if (tmp !== entry) {
              $scope.relatedsearches.push(entry);
            }
          });
        }
      });
    }
  });

  $scope.details = function(entry) {
    var modaleScope = $rootScope.$new(true);
    modaleScope.data = entry;

    var modal = $modal({
      show : true,
      scope : modaleScope,
      template : 'views/dam-details-modal.html',
      modalClass : 'dam-modal-edit dam-list-thumb-grid-modal confirm-modal ng-cloak',
      backdrop : 'static',
      keyboard : false
    });

    modaleScope.verified = (modaleScope.confirm !== true);

    var deferred = $q.defer();

    var destroyModal = function() {
      modal.then(function(modalEl) {
        modalEl.on('hidden.bs.modal', function() {
          modaleScope.$destroy();
          angular.element(this).remove();
        });

        modalEl.modal('hide');
      });
    };

    modaleScope.doCancel = function() {
      destroyModal();
      deferred.resolve(false);
    };

    modaleScope.cancel = function() {
      destroyModal();
      deferred.resolve(true);
    };

    return deferred.promise;
  };

  /*
   * Update for dynamic queries
   */
  $scope.$on("dam:searchNewItems", function(event, searchResponseData) {
    if (lastAdvdamid === searchResponseData.damid) {
      handleNewDynEntries(searchResponseData);
    }
  });

  $scope.$on("dam:searchRemovedItems", function (event, idsToRemove) {
    if (!idsToRemove || idsToRemove.length === 0) {
      return;
    }

    var entriesNum = $scope.entries.length;
    $scope.entries = $scope.entries.filter(function (entry) {
      return !idsToRemove.includes(entry.id);
    });
    // $scope.numFound represents the total number of matching contents,
    // whereas $scope.entries.length indicates the number of content on the current page.
    // Due to pagination, $scope.numFound can be calculated by subtracting the number of removed entries from the total.
    $scope.numFound -= entriesNum - $scope.entries.length;
  });

  $scope.loadMore = function() {
    loadingMore = true;
    if ($rootScope.lastAdvQueryData !== undefined) { // Advanced loadMore
      var lastFacetingFltQuery = $rootScope.lastAdvFilterQuery ? $rootScope.lastAdvFilterQuery : '';
      var filterQuery = $scope.isDynamicQuery ? lastFacetingFltQuery : lastFacetingFltQuery;
      var start = $scope.isDynamicQuery ? 0 : $scope.nextStart;
      DamService.getResults($rootScope.lastAdvQueryData, start, filterQuery, undefined , undefined , dynamicLoadMoreFilterQuery).then(function(searchResponse) {
        addEntries(searchResponse.data);
        maxResultDynQry += searchResponse.data.response.docs.length;
      }).finally(function() {
        loadingMore = false;
        $interval(function () {
          $scope.$root.$broadcast("dam:setSliderEvent", {});
        }, 500, 1);
      });
    } else { // Full Text loadMore
      DamService.getFullText($rootScope.lastSearch, $scope.nextStart).then(function(searchResponse) {
        addEntries(searchResponse.data);
      }).finally(function() {
        loadingMore = false;
        $interval(function () {
          $scope.$root.$broadcast("dam:setSliderEvent", {});
        }, 500, 1);
      });
    }
  };

    $rootScope.$on("dam:openPreviewImage", function(event, img) {
      $scope.open(img);
    });

    $scope.open = function(img) {
      if (img._data.aspects.contentData.data.objectType !== "image" && img._data.aspects.contentData.data.objectType !== "video") {
        return;
      }
      var confirmModal = DamPreviewModalController.create({
        'header' : $translate.getTranslationTable()._IMAGE_PREVIEW_,
        'close' : $translate.getTranslationTable()._CLOSE_BUTTON_,
        'url' : img._data.aspects.contentData.data.url,
        'thumbUrl' : img._data.aspects.contentData.data.thumbUrl,
        'inputTemplate' : img._data.aspects.contentData.data.inputTemplate,
        'id' : img._data.id
      });
    };

  $scope.substring = function(text) {
    var substring = text;
    if (text !== undefined && text.length > 100) {
      substring = text.substring(0, 100);
      substring += "...";
    }
    return substring;
  };

  $scope.setCurrentLineHeight = function(newHeight) {
    $scope.currentLineHeight = newHeight;
  };

  function checkSortWidget(id) {
    if(id === 'jobs') {
      UserProfileService.getUserProfile({"application": "desk"}).then(function (configuration) {
        if(atex.onecms.ObjectUtils.getByPath(configuration, "data/grid-state/gridEnabled")) {
          angular.element('.dam-sort-widget').addClass('disabled');
        }
      });
    }
    else if(!$scope.isDynamicQuery) {
      angular.element('.dam-sort-widget').removeClass('disabled');
    }
  }

  $scope.togglePhysPagesFullScreen = function() {
    $rootScope.$broadcast("dam:toggleFullScreen");
  };

  $scope.show = function(id, ignore) {
    if($scope.backupAutoShowNewItem) {
      $scope.autoShowNewItem = $scope.backupAutoShowNewItem;
    }

      $('#dam-list-list').css('overflow','auto');
      if (id === 'budget-list') {
        $("#dam-list-listview").remove();
        $scope.list = false;
        $scope.listBudget = true;
        $rootScope.listBudget = true;
        $scope.thumb_list = false;
        $scope.thumb = false;
        $scope.grid = false;
        $rootScope.displayResultsMode='list';
        $scope.jobs = false;
        $scope.showList = false;
        $scope.physPage = false;
        asyncShowList();
      } else if (id === 'list') {
        $('#dam-list-list').css('overflow','hidden');
        $scope.listBudget = false;
        $rootScope.listBudget = false;
        $scope.list = true;
        $scope.thumb_list = false;
        $scope.thumb = false;
        $scope.grid = false;
        $scope.jobs = false;
        $scope.physPage = false;
        asyncShowList();
      } else if (id === 'thumb-list') {
        $scope.listBudget = false;
        $rootScope.listBudget = false;
        $scope.list = false;
        $scope.thumb_list = true;
        $scope.thumb = false;
        $scope.grid = false;
        $scope.jobs = false;
        $scope.physPage = false;
        asyncShowList();
      } else if (id === 'thumb') {
        $scope.listBudget = false;
        $rootScope.listBudget = false;
        $scope.list = false;
        $scope.thumb_list = false;
        $scope.grid = false;
        $scope.jobs = false;
        $scope.thumb = true;
        $scope.physPage = false;
        $scope.justifyThumbs(true);
      } else if ( id === 'grid') {
        $scope.listBudget = false;
        $rootScope.listBudget = false;
        $scope.list = false;
        $scope.thumb_list = false;
        $scope.thumb = false;
        $scope.jobs = false;
        $scope.physPage = false;
        $scope.chooseRowSize(w.width(),false);
        $scope.grid = true;
        asyncShowList();
      } else if ( id === 'jobs') {
        $scope.listBudget = false;
        $rootScope.listBudget = false;
        $scope.list = false;
        $scope.thumb_list = false;
        $scope.thumb = false;
        $scope.grid = false;
        $scope.jobs = true;
        $scope.physPage = false;
        asyncShowList();
      } else if ( id === 'physical-page') {
        $scope.backupAutoShowNewItem = $scope.autoShowNewItem;
        $scope.autoShowNewItem = true;
        $scope.listBudget = false;
        $rootScope.listBudget = false;
        $scope.list = false;
        $scope.thumb_list = false;
        $scope.thumb = false;
        $scope.grid = false;
        $scope.jobs = false;
        if (!ignore) {
          $scope.togglePhysPagesFullScreen();
        }
        $scope.chooseRowSize(w.width(),false);
        $scope.physPage = true;

        asyncShowList();
    }
    checkSortWidget(id);
    $scope.firstTickSpan = ($scope.grid) ? 4 : 10;
    $scope.tickSpan = ($scope.grid) ? 2 : 10;

    $scope.$broadcast("dam:view-change",id);
  };

  $scope.justifyThumbs = function(redoFullJustification) {
    $timeout(function() {
      $rootScope.$broadcast("dam:justifyThumbs", redoFullJustification);
    });
  };

  $scope.filter_text = function(html_code, limit) {
    if (html_code !== undefined) {
      if (typeof html_code === "object" && typeof html_code.text === 'string') {
        html_code = html_code.text;
      }
      if (limit > 0) {
        html_code = $filter('limitHtml')(html_code, limit);
      }
    }
    return html_code;
  };

  $scope.to_trusted = function(html_code, limit) {
    return $sce.trustAsHtml($scope.filter_text(html_code, limit));
  };

  $scope.changeSort = function(sortValue) {
    $rootScope.damSortData.currentSortValue = sortValue;
    if (sortValue === '') {
      $rootScope.damSortData.currentSortOrderValue = "desc";
    }
    if ($scope.entries.length > 0) {
      $scope.refresh();
    }
  };

  $scope.changeSortOrder = function(sortOrderValue) {
    $rootScope.damSortData.currentSortOrderValue = sortOrderValue;
    if ($scope.entries.length > 0) {
      $scope.refresh();
    }
  };

  $scope.canRemoveFromCurrentFolder = function() {
    if ($scope.selected.length <= 0 || !$scope.folderId) {
      return false;
    }
    return true;
  };

  $scope.removeFromCurrentFolder = function() {
    if ($scope.selected.length <= 0 || !$scope.folderId) {
      return false;
    }
    var locked = false;
    var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);
    DamActivityService.lock(ids).then(function(responses){
      locked = true;
      var getPromises = $scope.selected.map(function(item) {
        return ContentService.getContent({id:item.id}).then(function(response) {
          return response;
        });
      });
      return $q.all(getPromises);
    }).then(function(contents) {
      var savePromises = [];
      contents.map(function(content) {
        var dirtyFolder;
        var updateInfo;
        if ($scope.isSmartFolder) {
          // Smart Folder unmerge metadata
          dirtyFolder = atex.dam.AngularUtils.unmergeMetadata(content, $scope.extraInfo);
          if (dirtyFolder) {
            updateInfo = { id: content.id, data: content.data, revision: content.revision};
            savePromises.push(ContentService.updateContent(updateInfo).then(function(response) {
              $rootScope.$broadcast("dam:itemDeleted", content.id);
              return response;
            }));
          }
        } else {
          // Phys Folder (remove from folderId)
          dirtyFolder = atex.dam.AngularUtils.unsetFolder(content, $scope.folderId);
          if (dirtyFolder) {
            updateInfo = { id: content.id, data: content.data, revision: content.revision};
            savePromises.push(ContentService.updateContent(updateInfo).then(function(response) {
              $rootScope.$broadcast("dam:itemDeleted", content.id);
              return response;
            }));
          }
        }
      });
      return $q.all(savePromises);
    }).then(function(contents) {
      DamActivityService.unlock(ids);
      $scope.showSpinner = false;
    }).then(null, function(error) {
      if (locked) {
        var message = $translate.getTranslationTable().__FOLDERS_CONTENT_REMOVE_ERROR_MSG__ + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
        DamActivityService.unlock(ids);
      }
      $scope.showSpinner = false;
    });
  };

  function getPlanningAspect(name, type) {
    return {
      data: {
        "_type": "atex.Planning",
        "taskType": type,
        "name": name
      }
    };
  }

  function lookUpName(content, type) {
    var name;

    if ((type === 'article') || (type === 'collection') ) {
      name = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/contentData/data/name');
    }

    if (type === 'image') {
      name = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/contentData/data/title');
    }

    if (type === 'video') {
      name = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/contentData/data/headline');
    }

    if(!name) {
      name = "No Name";
    }

    return name;
  }

  $scope.planning = function(contentId) {
    return ContentService.getContent({id: contentId}).then(function (content) {
      var planning = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/atex.Planning');
      var type = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/contentData/data/objectType');
      var name = lookUpName(content, type);

      if (!planning) {
        planning = getPlanningAspect(name, type);
      } else {
        planning.data.taskType = type;
        planning.data.name = name;
      }

      content.data.aspects['atex.Planning'] = planning;

      var transferInfo = {
        id: content.id,
        data: content.data,
        revision: content.revision
      };

      return ContentService.updateContent(transferInfo).then(function (result) {
        return {id: result.id, name: name, type: type};
      });
    });
  };

  function getName(contents, type) {
    var name;
    contents.forEach(function(content) {
      if ((content) && (content.type === type) && (!name)) {
        name = content.name;
      }
    });

    return name;
  }

  $scope.tasks = function () {
    var tasks = [];
    var types = ['article','image','collection','video'];

    var deferred = $q.defer();

    var promises = $scope.selected.map(function (entry) {
      return ContentService.getContent({id:entry.id}).then(function(content) {
        var type = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/contentData/data/objectType');
        var jobId = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/atex.Planning/data/jobId');

        if(types.includes(type) && (!jobId)) {
          return $scope.planning(entry.id);
        } else {
          var name = lookUpName(content, type);

          var message =  "\"" + name +  "\" ";
          if(types.includes(type)) {
            message = message + $translate.getTranslationTable().__ALREADY_SCHEDULED_ERROR__;
          } else {
            message = message + $translate.getTranslationTable().__WRONG_TYPE_ERROR__;
          }

          DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
          return;
        }
      });
    });

    $q.all(promises).then(function (responses) {
      var name;
      responses.forEach(function (response) {
        if(response) {
          tasks.push(atex.dam.AngularUtils.addPrefix(response.id));
        }
      });

      types.forEach(function(type) {
        if(!name) {
          name = getName(responses,type);
        }
      });

      if(!name) {
        name = "No Name";
      }

      deferred.resolve({tasks:tasks,name:name});
    }).then(null, function () {
      deferred.reject();
    });

    return deferred.promise;
  };

  $scope.createJob = function () {
    $scope.tasks().then(function (contents) {
      if( (contents) && (contents.tasks) && (contents.tasks.length > 0) ) {
        var content = atex.Content();

        content.data.aspects['contentData'] = {
          data: {
            "_type": "atex.dam.standard.Job",
            "objectType": "job",
            "inputTemplate": "p.DamJob",
            "tasks": contents.tasks,
            "name": contents.name
          }
        };

        /*content.data.aspects['p.InsertionInfo'] = {
          data: {
            _type: 'p.InsertionInfo',
            securityParentId: 'externalid/dam.assets.common.d'
          }
        };*/

        content.data.aspects['atex.Metadata'] = {
          data: {
            _type: 'atex.Metadata',
            taxonomyIds: ['p.StandardCategorization'],
            metadata: {
              _type: "com.polopoly.metadata.Metadata",
              dimensions: []
            }
          }
        };

        ContentService.createContent({data: content.data}).then(function (response) {
          ContentService.getContent({id: response.id}).then(function (entry) {
            var type = atex.onecms.ObjectUtils.getByPath(entry, 'data/aspects/contentData/data/_type') || "";
            DamSocialNotificationService.sendMessage(entry.id, type);

            $q.all(updateTasks(entry)).then(function () {
              entry._data = entry.data;
              $state.go('list.edit', {ids: [entry]});
            });
          });
        });
      }
    });
  };

  function updateTasks(entry) {
    var tasks = atex.onecms.ObjectUtils.getByPath(entry, 'data/aspects/contentData/data/tasks');
    var promises = tasks.map(function(task) {
      return ContentService.getContent({id: task}).then(function (content) {
        var planning = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/atex.Planning');
        planning.data.jobId = entry.id;

        var transferInfo = {
          id: content.id,
          data: content.data,
          revision: content.revision
        };

        return ContentService.updateContent(transferInfo).then(function (result) {
          return {id: result.id};
        });
      });
    });

    return promises;
  }

  $scope.moveToFolder = function() {
    if ($scope.selected.length <= 0) {
      return false;
    }
    var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);
    $window.atex.analytics('event', { e: 'moveToFolder', d1: ids});
    var modaleScope = $rootScope.$new(true);
    modaleScope.data = null;

    var modal = $modal({
      show : true,
      scope : modaleScope,
      template : 'views/dam-move-to-folder-modal.html',
      modalClass : 'ng-cloak',
      backdrop : 'static',
      keyboard : false
    });

    modaleScope.verified = (modaleScope.confirm !== true);

    var deferred = $q.defer();

    var destroyModal = function() {
      modal.then(function(modalEl) {
        modalEl.on('hidden.bs.modal', function() {
          modaleScope.$destroy();
          angular.element(this).remove();
        });

        modalEl.modal('hide');
      });
    };

    modaleScope.doCancel = function() {
      destroyModal();
      deferred.resolve(false);
    };

    modaleScope.cancel = function() {
      destroyModal();
      deferred.resolve(true);
    };

    return deferred.promise;
  };

  $scope.cancelSelectedQuery = function() {
    resetExtraInfo();
    $rootScope.$broadcast("dam:clearCurrentQuery");
    DamFoldersService.resetSelection(true);
    DamQueuesService.resetSelection(true);
    $rootScope.$broadcast("dam:clearFolderInfo");
    $scope.resetlist(true);
  };

  $scope.$on("dam:clearFolderInfo", function() {
    resetExtraInfo();
  });

  $scope.$on("dam:refresh", function() {
    $scope.refresh();
  });

  asyncShowList();
}]);
